/* Theme-side adapter for the real UpCart app; only definitive PDP bundle lines are changed. */
(() => {
  'use strict';
  if (window.GndUpcart) return;
  const stylesheet = new URL(document.currentScript.dataset.styles, location.href).href;
  const isMember = item => item?.properties?._gnd_source === 'definitive-pdp' && item.properties._gnd_group;
  const rowSelector = '[data-upcart-line-item]';
  const controls = '.upcart-public-component-product-tile__quantity-selector,.upcart-public-component-product-tile__remove-button,.upcart-public-component-product-tile__subscription-upgrade,.upcart-product-quantity-input,.upcart-product-quantity-minus,.upcart-product-quantity-plus,.upcart-product-remove-button';
  const checkout = '.upcart-checkout-button,[href*="/checkout"],[name="checkout"]';
  let root, observer, scheduled = false, busy = false, subscribed = false, previousOpenOverride, currency = 'USD';
  // UpCart's public serialization flag gives each rendered row its exact Shopify line key.
  // Variant IDs alone cannot distinguish two bundles containing the same products.
  window.upcartShouldSerializeLineItemsToDOM = true;
  const previousModify = window.upcartModifyCart;
  window.upcartModifyCart = cart => {
    cart = previousModify?.(cart) || cart;
    if (cart?.currency) currency = cart.currency;
    if (!cart?.items?.some(isMember)) return cart;
    const groups = new Map();
    cart.items.filter(isMember).forEach(item => {
      const key = item.properties._gnd_group;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(item);
    });
    const ordered = [], emitted = new Set();
    const giftOrder = Object.values(window.GndBundleCart?.gifts || {});
    const rank = item => ['bundle','day'].includes(item.properties._gnd_role) ? 0 : item.properties._gnd_role === 'night' ? 1 : 2 + Math.max(0,giftOrder.indexOf(Number(item.variant_id || item.id)));
    cart.items.forEach(item => {
      const group = isMember(item);
      if (!group) { ordered.push(item); return; }
      if (emitted.has(group)) return;
      emitted.add(group);
      ordered.push(...groups.get(group).sort((a,b) => rank(a) - rank(b)));
    });
    return {...cart, items:ordered};
  };
  function itemOf(row) {
    try { return JSON.parse(row?.getAttribute('data-upcart-line-item') || 'null'); }
    catch (_) { return null; }
  }
  function textElement(tag, className, text) {
    const el = document.createElement(tag); el.className = className; el.textContent = text; return el;
  }
  function decorateBundle(row, item) {
    if (item.properties._gnd_role !== 'bundle') return;
    const info = row.querySelector('.upcart-public-component-product-tile__info') || row;
    const contents = String(item.properties._gnd_contents || '').slice(0,240);
    let description = row.querySelector('.gnd-upcart-contents');
    if (contents) {
      if (!description) { description = textElement('p','gnd-upcart-contents',''); info.append(description); }
      description.textContent = contents;
    } else description?.remove();
    row.querySelector('.gnd-upcart-renewal')?.remove();
    // Leave UpCart's original product image intact for its fallback presentation.
  }
  const giftDesign = {
    63446702030988: {name:'iPhone 18 Pro draw entry', asset:'gnd-speed-59530cee3979-96.webp', prize:119900, rank:0},
    63446696558732: {name:'Mystery Gift', asset:'gnd-speed-c37c7c8f58e6-96.webp', value:1995, rank:1},
    63446695903372: {name:'Free shipping', asset:'gnd-speed-75dd502b4742-96.webp', value:495, rank:2},
    63446695837836: {name:'60-day money-back guarantee', asset:'gnd-speed-f1b73d3a9585-96.webp', rank:3}
  };
  const money = (cents, compact=false) => new Intl.NumberFormat('en-US', {
    style:'currency', currency, minimumFractionDigits:compact ? 0 : 2, maximumFractionDigits:2
  }).format(cents / 100);
  function cartImage(src, alt, width, height) {
    const image = document.createElement('img');
    image.src = src; image.alt = alt; image.width = width; image.height = height; image.loading = 'lazy';
    return image;
  }
  // Keep UpCart's serialized rows, checkout, cart state and lifecycle. This is a
  // presentation of the existing preset parent and its real gift lines, not a second cart.
  function decoratePreset(lines) {
    const parent = lines.find(({item}) => item.properties._gnd_role === 'bundle');
    const key = parent?.item.properties._gnd_bundle;
    const counts = {starter:[1,0],duo:[1,1],complete:[2,1]}[key];
    if (!parent || !counts || lines.some(({item}) => !['bundle','gift'].includes(item.properties._gnd_role))) return;
    const {row,item} = parent;
    const signature = JSON.stringify([currency,lines.map(line => line.item)]);
    row.classList.add('gnd-upcart-preset');
    lines.forEach(line => {
      const hidden = line !== parent;
      line.row.classList.toggle('gnd-upcart-collapsed',hidden);
      if (hidden) { line.row.setAttribute('inert',''); line.row.setAttribute('aria-hidden','true'); }
    });
    if (row.querySelector('.gnd-ref-cart')?.dataset.signature === signature) return;
    const card = textElement('article','gnd-ref-cart',''); card.dataset.signature = signature;
    const heading = textElement('header','gnd-ref-cart__heading','');
    heading.append(textElement('h3','',item.properties._gnd_title || 'Your bundle'));
    const remove = textElement('button','gnd-ref-cart__remove','');
    remove.type = 'button'; remove.dataset.gndUpcartRemove = item.properties._gnd_group;
    remove.setAttribute('aria-label',`Remove ${item.properties._gnd_title || 'bundle'} and all included gifts`);
    remove.title = 'Remove bundle'; remove.disabled = busy;
    remove.innerHTML = '<svg viewBox="0 0 24 26" aria-hidden="true" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7m4-7v7"/></svg>';
    heading.append(remove); card.append(heading);
    const products = textElement('div','gnd-ref-cart__products','');
    const images = textElement('div','gnd-ref-cart__images','');
    // Read the selected bundle's current Shopify image from the real cart line.
    // Editing the product/variant image in Shopify updates this card automatically.
    let productImage;
    for (const source of [item.featured_image?.url, item.image]) {
      if (!source) continue;
      try {
        const url = new URL(source, location.origin);
        if (url.protocol !== 'https:' || ![location.hostname,'cdn.shopify.com'].includes(url.hostname)) continue;
        url.searchParams.set('width','240');
        productImage = url.href;
        break;
      } catch (_) {}
    }
    if (productImage) {
      images.classList.add('gnd-ref-cart__images--product');
      images.append(cartImage(productImage,item.product_title || item.properties._gnd_title || 'Your bundle',106,96));
    } else {
      let sources = [];
      try { sources = [...new Set(JSON.parse(item.properties._gnd_images || '[]'))].map(src => new URL(src,location.origin)).filter(url => url.protocol === 'https:' && (url.hostname === location.hostname || url.hostname === 'cdn.shopify.com')).map(url => url.href); } catch (_) {}
      const defaults = ['gnd-speed-f9bb4d7358bf-120.webp','gnd-speed-e9840bfb30da-120.webp'];
      counts.forEach((count,index) => {
        for (let bottle=0; bottle<count; bottle++) images.append(cartImage(sources[index] || new URL(defaults[index],stylesheet).href,index ? 'Nuora Enzyme Gummies' : 'Nuora Gut Ritual',52,76));
      });
    }
    products.append(images);
    const copy = textElement('div','gnd-ref-cart__copy','');
    counts.forEach((count,index) => {
      if (!count) return;
      const title = textElement('h4','',index ? 'Nuora Enzyme Gummies ' : 'Nuora Gut Ritual ');
      title.append(textElement('span','gnd-ref-cart__quantity','×'+count*item.quantity)); copy.append(title);
    });
    const total = lines.reduce((sum,line) => sum + (line.item.final_line_price ?? line.item.line_price ?? 0),0);
    const configuredCompare = document.querySelector(`[data-bundle-key="${key}"]`)?.dataset.compare;
    const compare = currency === 'USD' ? Number(configuredCompare || {starter:6900,duo:12700,complete:19600}[key])*item.quantity : item.original_line_price;
    const prices = textElement('div','gnd-ref-cart__price','');
    if (compare > total) prices.append(textElement('del','',money(compare)));
    prices.append(textElement('strong','',money(total))); copy.append(prices);
    if (compare > total) copy.append(textElement('p','gnd-ref-cart__saving','Save '+money(compare-total,true)));
    products.append(copy); card.append(products);
    const gifts = lines.filter(line => line.item.properties._gnd_role === 'gift').sort((a,b)=>(giftDesign[a.item.variant_id]?.rank ?? 9)-(giftDesign[b.item.variant_id]?.rank ?? 9));
    if (gifts.length) {
      const section = textElement('section','gnd-ref-cart__gifts','');
      section.setAttribute('aria-label','Included gifts and benefits'); section.append(textElement('h4','gnd-ref-cart__gifts-heading','GIFTS INCLUDED'));
      gifts.forEach(({item:gift}) => {
        const design = giftDesign[gift.variant_id] || {};
        const giftRow = textElement('div','gnd-ref-cart__gift','');
        const src = design.asset ? new URL(design.asset,stylesheet).href : gift.image;
        if (src) giftRow.append(cartImage(src,design.name || gift.product_title,40,40));
        const details = textElement('div','',''); details.append(textElement('p','',design.name || gift.product_title));
        const price = textElement('div','gnd-ref-cart__gift-price','');
        if (design.value && currency === 'USD') price.append(textElement('del','',money(design.value)));
        else price.append(textElement('span','gnd-ref-cart__gift-value',design.prize && currency === 'USD' ? 'Prize value '+money(design.prize) : 'Included'));
        price.append(textElement('strong','',money(gift.final_line_price ?? gift.line_price ?? 0)+(design.prize ? ' entry' : '')));
        if (design.value && currency === 'USD' && (gift.final_line_price ?? gift.line_price) === 0) price.append(textElement('span','gnd-ref-cart__gift-saving','(SAVE '+money(design.value)+')'));
        details.append(price); giftRow.append(details); section.append(giftRow);
      }); card.append(section);
    }
    const status = textElement('p','gnd-upcart-status',''); status.setAttribute('role','status'); card.append(status);
    row.querySelector('.gnd-ref-cart')?.remove();
    Array.from(row.children).forEach(child => { child.setAttribute('inert',''); child.setAttribute('aria-hidden','true'); });
    row.append(card);
  }
  function decorate() {
    if (!root) return;
    observer.disconnect();
    try {
      const groups = new Map();
      root.querySelectorAll(rowSelector).forEach(row => {
        const item = itemOf(row), group = isMember(item);
        if (!group) {
          if (row.dataset.gndUpcartGroup) {
            row.classList.remove('gnd-upcart-member','gnd-upcart-gift','gnd-upcart-first','gnd-upcart-last','gnd-upcart-first-gift','gnd-upcart-preset','gnd-upcart-collapsed');
            delete row.dataset.gndUpcartGroup;
            row.removeAttribute('inert'); row.removeAttribute('aria-hidden');
            row.querySelectorAll('.gnd-ref-cart,.gnd-upcart-heading,.gnd-upcart-line-note,.gnd-upcart-contents,.gnd-upcart-renewal,.gnd-upcart-gifts-heading').forEach(el => el.remove());
            row.querySelectorAll('[inert],[aria-hidden="true"]').forEach(el => { el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); });
          }
          return;
        }
        row.dataset.gndUpcartGroup = group;
        row.classList.add('gnd-upcart-member');
        row.classList.toggle('gnd-upcart-gift', item.properties._gnd_role === 'gift');
        row.querySelectorAll(controls).forEach(el => {
          el.setAttribute('inert','');
          el.setAttribute('aria-hidden','true');
        });
        if (item.properties._gnd_role === 'gift') row.querySelectorAll('a[href]').forEach(el => {
          el.removeAttribute('href'); el.removeAttribute('tabindex');
        });
        if (!groups.has(group)) groups.set(group, []);
        groups.get(group).push({row,item});
        decorateBundle(row,item);
        let note = row.querySelector('.gnd-upcart-line-note');
        if (!note) {
          note = textElement('p','gnd-upcart-line-note','');
          (row.querySelector('.upcart-public-component-product-tile__info') || row).append(note);
        }
        const subscription = item.selling_plan_allocation?.selling_plan?.name || 'Subscription';
        note.textContent = item.properties._gnd_role === 'gift' ? 'Included gift' : `Qty: ${item.quantity} · ${subscription}`;
      });
      const rows = Array.from(root.querySelectorAll(rowSelector));
      root.querySelector('.upcart-cart')?.classList.toggle('gnd-upcart-only',rows.length > 0 && rows.every(row => isMember(itemOf(row))));
      groups.forEach(lines => {
        const giftLines = lines.filter(({item}) => item.properties._gnd_role === 'gift');
        lines.forEach(({row}, index) => {
          row.classList.toggle('gnd-upcart-first', index === 0);
          row.classList.toggle('gnd-upcart-last', index === lines.length - 1);
          if (index !== 0) row.querySelector('.gnd-upcart-heading')?.remove();
          const firstGift = row === giftLines[0]?.row;
          row.classList.toggle('gnd-upcart-first-gift', firstGift);
          if (!firstGift) row.querySelector('.gnd-upcart-gifts-heading')?.remove();
          else {
            let giftHeading = row.querySelector('.gnd-upcart-gifts-heading');
            if (!giftHeading) { giftHeading = textElement('div','gnd-upcart-gifts-heading',''); row.prepend(giftHeading); }
            giftHeading.textContent = `Included gifts (${giftLines.length})`;
          }
        });
        const {row,item} = lines[0];
        if (!row.querySelector('.gnd-upcart-heading')) {
          const heading = textElement('div','gnd-upcart-heading','');
          heading.append(textElement('strong','gnd-upcart-title',item.properties._gnd_title || 'Your bundle'));
          const button = textElement('button','gnd-upcart-remove','Remove bundle');
          button.type = 'button'; button.dataset.gndUpcartRemove = item.properties._gnd_group;
          button.setAttribute('aria-label',`Remove ${item.properties._gnd_title || 'bundle'} and all included gifts`);
          heading.append(button);
          const status = textElement('p','gnd-upcart-status',''); status.setAttribute('role','status');
          heading.append(status); row.prepend(heading);
        }
        try { decoratePreset(lines); }
        catch (error) {
          // An optional presentation failure must never hide purchasable cart lines.
          lines.forEach(({row}) => {
            row.classList.remove('gnd-upcart-preset','gnd-upcart-collapsed');
            row.removeAttribute('inert'); row.removeAttribute('aria-hidden');
            row.querySelector('.gnd-ref-cart')?.remove();
            Array.from(row.children).forEach(child => { child.removeAttribute('inert'); child.removeAttribute('aria-hidden'); });
          });
          console.warn('Nuora cart presentation could not be applied.',error);
        }
      });
    } finally { observer.observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['data-upcart-line-item']}); }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; connect(); decorate(); });
  }
  function connect() {
    const next = window.upcartDocumentOrShadowRoot || document.getElementById('upCart')?.shadowRoot;
    if (!next || next === root) return;
    observer?.disconnect(); root = next;
    const link = document.createElement('link'); link.rel = 'stylesheet'; link.href = stylesheet;
    link.dataset.gndUpcartStyles = ''; (root.head || root).append(link);
    root.addEventListener('click', onClick, true);
    observer = new MutationObserver(schedule);
    observer.observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['data-upcart-line-item']});
  }
  function setBusy(value) {
    if (busy === value) return;
    busy = value;
    if (value) {
      previousOpenOverride = window.upcartShouldOpenOnAddToCartBackgroundNetworkCall;
      window.upcartShouldOpenOnAddToCartBackgroundNetworkCall = false;
    } else window.upcartShouldOpenOnAddToCartBackgroundNetworkCall = previousOpenOverride;
    const host = root?.host || document.getElementById('upCart');
    host?.toggleAttribute('data-gnd-busy', value);
    root?.querySelectorAll('[data-gnd-upcart-remove]').forEach(button => button.disabled = value);
  }
  async function onClick(event) {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const row = target.closest(rowSelector), item = itemOf(row);
    const remove = target.closest('[data-gnd-upcart-remove]');
    if (busy && (target.closest(checkout) || remove)) {
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    if (isMember(item) && !remove && (target.closest(controls) || (item.properties._gnd_role === 'gift' && target.closest('a')))) {
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    if (!remove) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const status = row.querySelector('.gnd-ref-cart .gnd-upcart-status') || row.querySelector('.gnd-upcart-status');
    setBusy(true); status.textContent = '';
    try {
      await window.GndBundleCart.remove(remove.dataset.gndUpcartRemove);
      await render(false);
    } catch (error) { status.textContent = error.message || 'Could not remove this bundle. Please try again.'; }
    finally { setBusy(false); }
  }
  async function ready() {
    for (let attempt = 0; attempt < 60; attempt++) {
      if (window.upcartGetCart?.()?.items && typeof window.upcartRefreshCart === 'function') { connect(); return; }
      await new Promise(resolve => setTimeout(resolve, 200));
    }
    throw new Error('UpCart is not available.');
  }
  async function render(open) {
    await ready(); await window.upcartRefreshCart(); schedule();
    if (open) window.upcartOpenCart();
  }
  window.GndUpcart = {render,setBusy};
  function subscribe() {
    if (subscribed || typeof window.upcartSubscribeCartLoaded !== 'function') return subscribed;
    subscribed = true;
    window.upcartSubscribeCartLoaded(schedule);
    window.upcartSubscribeCartUpdated(schedule);
    window.upcartSubscribeCartOpened(schedule);
    schedule();
    return true;
  }
  // Bind before the first cart fetch completes, including a delayed app script load.
  document.addEventListener('load', event => {
    if (event.target instanceof HTMLScriptElement && /upcart/.test(event.target.src)) subscribe();
  }, true);
  window.addEventListener('load', subscribe, {once:true});
  if (!subscribe()) {
    let tries = 0;
    const timer = setInterval(() => { if (subscribe() || ++tries >= 60) clearInterval(timer); }, 250);
  }
})();
